// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1K_r9","rightAdornment":"Header_rightAdornment__2zjBt"};